export default class HeaderConfig {

	headerMobile;
	headerWrapper;

	constructor() {
		this.headerWrapper = document.querySelector('header .header-wrapper');
		this.headerMobile = document.querySelector('header .header-mobile');
	}

	setupDefaultHeaderWrapperClasses = () => {
		//Check availability of hero bleed banner s
		if(this.headerWrapper) {
			const heroBleedBannerSWithOverlay = document.querySelector('.hero-bleed-banner-s.has-header-overlay');

			if(heroBleedBannerSWithOverlay){
				this.headerWrapper.classList.add('is-transparent');
				this.headerMobile.classList.add('is-transparent');
			} else {
				this.headerWrapper.classList.remove('is-transparent');
				this.headerMobile.classList.remove('is-transparent');
			}
		}
	}

	setCssVariablesForHeader = () => {
		const appHeight = () => document.documentElement.style.setProperty( '--app-height', `${window.innerHeight}px` )
		const headerMobileHeight = () => {
			const headerMobileEle = document.querySelector('.header-mobile');
			if(headerMobileEle){
				document.documentElement.style.setProperty( '--header-mobile-height', `${headerMobileEle.offsetHeight}px` )
			}
		}
		const headerDesktopHeight = () => {
			const headerWrapperEle = document.querySelector('.header-desktop');
			if(headerWrapperEle){
				document.documentElement.style.setProperty( '--header-desktop-height', `${headerWrapperEle.offsetHeight}px` )
			}
		}

		const adminBarHeight = () => {
			const adminBarEle = document.querySelector('#wpadminbar');
			if(adminBarEle) {
				document.documentElement.style.setProperty( '--admin-bar-height', `${adminBarEle.offsetHeight}px` );
			} else {
				document.documentElement.style.setProperty( '--admin-bar-height', `0px` )
			}
		}

		/**
		 * Get the height of the breadcrumb
		 */
		const subNavWrapperHeight = () => {
			const subNavEle = document.querySelector('.sub-navigation-wrapper');
			if(subNavEle) {
				document.documentElement.style.setProperty( '--sub-navigation-wrapper-height', `${subNavEle.offsetHeight}px` );
			} else {
				document.documentElement.style.setProperty( '--sub-navigation-wrapper-height', `0px` )
			}
		}

		window.addEventListener( 'resize', () => {
			appHeight();
			subNavWrapperHeight();
			headerDesktopHeight();
			adminBarHeight();
			headerMobileHeight();
		})
		appHeight();
		subNavWrapperHeight();
		headerMobileHeight();
		headerDesktopHeight();
		adminBarHeight();
	}

}
